import React from 'react';
import { motion } from 'framer-motion';
export function Terms() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white min-h-screen py-20" data-id="element-563">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-564">
        <h1 className="text-4xl font-black text-slate-900 mb-8 uppercase tracking-tighter" data-id="element-565">
          Terms of Service
        </h1>
        <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed" data-id="element-566">
          <p className="text-lg font-medium text-slate-900" data-id="element-567">
            Last Updated: May 19, 2026
          </p>
          <p data-id="element-568">
            By accessing or using the Daily Care Pharmacy website, you agree to
            be bound by these Terms of Service. Please read them carefully
            before using our services.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-569">
            Use of Services
          </h2>
          <p data-id="element-570">
            Our services are intended for personal, non-commercial use. You
            agree to provide accurate information when requesting prescription
            refills or clinical services.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-571">
            Medical Disclaimer
          </h2>
          <p data-id="element-572">
            The information provided on this website is for informational
            purposes only and is not a substitute for professional medical
            advice, diagnosis, or treatment. Always seek the advice of your
            physician or other qualified health provider.
          </p>
          <h2 className="text-2xl font-bold text-slate-900 pt-4" data-id="element-573">
            Limitation of Liability
          </h2>
          <p data-id="element-574">
            Daily Care Pharmacy shall not be liable for any direct, indirect,
            incidental, or consequential damages arising out of your use of our
            website or services.
          </p>
        </div>
      </div>
    </motion.div>;
}